import {
    makeAction,
    UPDATE_LOGIN_SESSION,
    UPDATE_USER_LOGGING_IN,
    UPDATE_LOGIN_ERROR
} from './index';

export const updateLoginSession = (isUserLoggedIn, loginTokenType) =>
    makeAction(UPDATE_LOGIN_SESSION,
        { isLoggedIn: isUserLoggedIn, loginTokenType: loginTokenType});

export const updateUserLoggingIn = (isUserLoggingIn) =>
    makeAction(UPDATE_USER_LOGGING_IN,
        { isLoggingIn: isUserLoggingIn });

export const updateLoginError = (isError) =>
    makeAction(UPDATE_LOGIN_ERROR,
        { isLoginError: isError });


// WEBPACK FOOTER //
// ./src/actions/session_handler.js